import React from 'react';
import './footer.styles.css';

const FooterComponent = (props) =>{
    return (
        <div className="footer text-center fixed-bottom">
            <p className="mb-0 pb-0">Aayush Soni</p>
            <p className="mb-0 pb-0 text-muted">&copy; All right reserved. 2020-2021</p>
        </div>
    );
}

export default FooterComponent;